import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { saveAs } from 'file-saver/FileSaver';
import { of } from 'rxjs';
import { ModalComponent } from '../../../../../vass-core/components/modal/modal.component';
import { BeginReviewService } from '../../../../services/begin-review/begin-review.service';

@Component({
  selector: 'app-confirm-data-sec-holder-modal',
  templateUrl: './confirm-data-sec-holder-modal.component.html',
  styleUrls: ['./confirm-data-sec-holder-modal.component.scss'],
  standalone: false,
})
export class ConfirmDataSecHolderModalComponent implements OnInit {
  confirmForm: UntypedFormGroup;
  public pfdDownloaded: boolean = !!sessionStorage.getItem('pfdDownloaded');
  public msgPDFDownloaded: string = '';

  public downloading = false;
  public isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  public urlFipre: SafeUrl = '';

  constructor(
    public modalComponent: ModalComponent,
    private formBuilder: UntypedFormBuilder,
    private _beginReviewService: BeginReviewService,
    private sanitizer: DomSanitizer,
  ) {
    if (this.modalComponent.data) {
    }
  }

  ngOnInit() {
    this.initForm();
    if (this.isSafari) {
      this.getUrlPDF();
    }
  }

  initForm() {
    this.confirmForm = this.formBuilder.group({
      fipre: [false, Validators.required, this.isChecked.bind(this)],
      cirbe: [false, Validators.required, this.isChecked.bind(this)],
      protection_clauses_1: [false, Validators.required, this.isChecked.bind(this)],
      protection_clauses_2: [false, Validators.required, this.isChecked.bind(this)],
    });
  }

  isChecked(control: AbstractControl) {
    let respuesta;
    if (!control.value) {
      respuesta = { validateUsername: control.value };
    }
    return of(respuesta);
  }

  sendForm() {
    if (this.confirmForm.valid && this.pfdDownloaded) {
      this.modalComponent.sendDataFromModal({
        ref: this.modalComponent,
        data: this.confirmForm.value,
      });
    } else {
      for (const campo in this.confirmForm.controls) {
        this.confirmForm.controls[campo].markAsTouched();
      }
      this.pfdDownloaded
        ? (this.msgPDFDownloaded = '')
        : (this.msgPDFDownloaded = 'begin_review_must_download_document');
    }
  }

  getUrlPDF() {
    this._beginReviewService.getPDFfipre().subscribe(
      (blob) => {
        this.urlFipre = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
      },
      (err) => {},
    );
  }

  setDownloaded() {
    this.pfdDownloaded = true;
    this.msgPDFDownloaded = '';
    sessionStorage.setItem('pfdDownloaded', 'true');
  }

  downloadFIPRE() {
    this._beginReviewService.getPDFfipre().subscribe(
      (resp) => {
        this.pfdDownloaded = true;
        this.msgPDFDownloaded = '';
        sessionStorage.setItem('pfdDownloaded', 'true');
        saveAs(resp, 'fipre');
      },
      (err) => {},
    );
  }

  openToast(id: string) {
    const elementHTML = document.getElementById(id);
    elementHTML.blur();
    elementHTML.focus();
  }
}
